import React from 'react';
import { Box } from '@mui/material';
import { ArrowDownward, ArrowUpward, ReceiptLongOutlined } from '@mui/icons-material';
import { AccountMovement, AccountMovementType, Debt, DebtType } from '../../types';

export type MovementRecord = Debt | AccountMovement;

export const isSaleLinked = (debt: MovementRecord): boolean => Boolean(
  debt.saleId
  || ('debtType' in debt && debt.debtType === DebtType.SALE)
  || ('movementType' in debt && (debt.movementType === AccountMovementType.SALE || debt.movementType === AccountMovementType.CANCELLATION)),
);

export const movementKind = (debt: MovementRecord): 'sale' | 'payment' | 'debt' => {
  if ('movementType' in debt) {
    if (debt.movementType === AccountMovementType.SALE || debt.movementType === AccountMovementType.CANCELLATION) return 'sale';
    if (debt.movementType === AccountMovementType.MANUAL_PAYMENT) return 'payment';
    return 'debt';
  }
  return debt.amount < 0 ? 'payment' : isSaleLinked(debt) ? 'sale' : 'debt';
};

export function DebtMovementIcon({ debt }: { debt: MovementRecord }) {
  const kind = movementKind(debt);
  const color = kind === 'payment' ? 'success.main' : 'error.main';
  const backgroundColor = kind === 'payment' ? 'rgba(35, 96, 68, .10)' : 'rgba(164, 54, 47, .09)';
  return (
    <Box sx={{ width: 38, height: 38, borderRadius: 1.25, display: 'grid', placeItems: 'center', color, backgroundColor, flexShrink: 0 }} aria-hidden="true">
      {kind === 'sale' ? <ReceiptLongOutlined fontSize="small" /> : kind === 'payment' ? <ArrowDownward fontSize="small" /> : <ArrowUpward fontSize="small" />}
    </Box>
  );
}
